import get from 'lodash/get';

export const getBlockSectionQuery = (state) => get(state, ['vegetation', 'addressblocksection', 'query']);
export const getSuburbs = (state) => get(state, ['vegetation', 'addressblocksection', 'suburbs']);




// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/addressblocksection.js